import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { AnalyticsService } from 'src/app/_services/analytics.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { clickGAEvent, pageLoadEvent } from 'src/app/_helpers/ga-events';
import { addGAEventListener } from 'src/app/_helpers/ga-events';
import { removeGAEventListener } from 'src/app/_helpers/ga-events';
import * as Sentry from '@sentry/angular-ivy';
//import { WindowRef } from '../../zoho-salesiq/WindowRef';
declare var zcAction: any;
declare var waListSubscribe: any;
@Component({
  selector: 'tp-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  //providers: [WindowRef]
})
export class LoginComponent implements OnInit {
  validateForm!: UntypedFormGroup;
  submitted = false;
  errorMsg: string = '';
  errorValue = 'success';
  window: any;
  // isShow = false;

  passwordVisible: boolean = false;
  returnUrl: string | undefined;
  user: any;
  logo: any;
  tenant: boolean = false;

  constructor(
    //private winRef: WindowRef,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private analyticsService: AnalyticsService
  ) {
    //this.window = winRef.nativeWindow;
  }

  ngOnInit() {
    this.checkIfTenant();
    pageLoadEvent('login_page');
    addGAEventListener();
    this.user = this.authService.getUser();
    this.validateForm = this.fb.group({
      email: [null, [Validators.email, Validators.required]],
      password: [null, [Validators.required, Validators.minLength(6)]],
    });
  }

  ngAfterViewInit(): void {
    removeGAEventListener();
    addGAEventListener();
  }

  ngOnDestroy(): void {
    removeGAEventListener();
  }

  get f() {
    return this.validateForm.controls;
  }

  checkIfTenant() {
    let getLink = window.location.href;
    const isSubdomain = (trial: any) => trial.split('.').length > 2;
    const { hostname } = new URL(getLink);
    // needs to check for dynamically setting logo later
    if (
      hostname !== 'prod.terragoncpaas.com' &&
      hostname !== 'dev.terragoncpaas.com' &&
      isSubdomain(hostname)
    ) {
      localStorage.setItem('tenant', 'true');
      localStorage.setItem('subDomainName', getLink);
      this.tenant = true;
      this.logo =
        hostname === 'fidelity-cpaas.terragonltd.com'
          ? '../assets/icons/fidelity.svg'
          : hostname === 'oxygen-cpaas.terragonltd.com'
          ? '../assets/icons/oxygen.svg'
          : hostname === 'ocpaasstaging.terragonbase.com' ||
            hostname === 'acc-cpaas.terragonltd.com'
          ? '../assets/icons/terragonLogo.svg'
          : hostname === 'aramex.terragoncpaas.com'
          ? '../assets/icons/aramex.svg'
          : hostname === 'abstaging-cpaasdev.terragoncpaas.com'
          ? '../assets/icons/access.svg'
          : hostname === 'hydrogencpaas.terragoncpaas.com'
          ? '../assets/icons/hydrogen.svg'
          : '../assets/icons/user-dummy.png';
    } else {
      localStorage.setItem('tenant', 'false');
      this.tenant = false;
      this.logo = '../../../assets/icons/terragonLogo.svg';
    }
  }

  submitForm() {
    this.submitted = true;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
    if (this.validateForm.valid) {
      this.authService
        .login(this.f.email.value, this.f.password.value)
        .pipe(first())
        .subscribe({
          next: (res: any) => {
            if (!res.error) {
              this.analyticsService.loginEvent(true);
              if (this.returnUrl) {
                if (this.tenant) {
                  this.router.navigate(['dashboard']);
                } else {
                  this.router.navigate(['/business/list']);
                }
              } else {
                if (this.tenant) {
                  this.router.navigate(['dashboard']);
                } else {
                  this.router.navigate(['/business/list']);
                }
              }
            } else {
              this.router.navigate(['dashboard']);
              Sentry.captureMessage('Error: ' + res.error);
              this.errorMsg = res.response;
              this.errorValue = res.error ? 'error' : 'success';
              this.analyticsService.loginEvent(false);
              this.router.navigate(['/auth/login']);
            }
          },
          error: (err: any) => {
            Sentry.captureMessage('Error: ' + err.response);
            if (err.response?.user?.account_status == 'partially approved') {
              this.router.navigateByUrl(
                `/auth/newbusiness?token=${err.response.token}`
              );
            } else {
              this.errorMsg = err.response;
              this.errorValue = err.error ? 'error' : 'success';
              this.router.navigate(['/auth/login']);
            }
          },
        });
    } else {
      Object.values(this.validateForm.controls).forEach((control) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  goTo(url: any) {
    this.router.navigate([url]);
  }

  triggerGAClick(): void {
    clickGAEvent('button_click', 'login-forgot-password_click', 'login_page');
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  // mobileContentHide(){
  //   this.isShow = !this.isShow;
  // }
}
